import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
    path: 'patient_id',
  })
  let submitGlobal = useDataSubmit({
    viewPath: props.viewPath,
    context: 'global',
  })

  return () => {
    submitGlobal({
      type: 'patientOverlay/open',
      patient_id,
    })
  }
}
